import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CircleIcon from '@mui/icons-material/Circle';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import StarRateIcon from '@mui/icons-material/StarRate';
import { Typography, Box, Slider } from '@mui/material';
import { SliderThumb } from '@mui/material/Slider';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { languages, locale } from '../../config/language.config';
import { formatDollarAmount, formatNumber } from '../../utils/formatter';
import { Tooltip } from '../Tooltip/Tooltip';
import styles from './styles';
const CustomThumb = ({ content, className, ...other }) => {
    return (_jsxs(SliderThumb, { ...other, className: 'thumb ' + className, children: [_jsx(Tooltip, { containerIdentification: '.goal-progress-card', children: _jsx(Typography, { noWrap: true, variant: 'body1', children: content }) }), className?.split(' ').includes('starred') ? (_jsx(StarRateIcon, { color: 'primary' })) : (_jsx(CircleIcon, { color: 'primary' }))] }));
};
const ProgressBar = ({ min = 0, max, current, sx, starred = false, isDollarAmount = true, }) => {
    const { i18n: { resolvedLanguage }, } = useTranslation();
    const resolvedLocale = resolvedLanguage === languages.fr ? locale.fr : locale.en;
    return (_jsxs(Box, { sx: sx, children: [_jsx(Slider, { min: min, max: max, value: current, sx: styles.progressBar, slots: {
                    thumb: CustomThumb,
                }, slotProps: {
                    thumb: {
                        content: (isDollarAmount
                            ? formatDollarAmount(current, resolvedLocale)
                            : formatNumber(current)) +
                            ' / ' +
                            (isDollarAmount ? formatDollarAmount(max, resolvedLocale) : formatNumber(max)),
                        className: starred ? 'starred' : 'default',
                    },
                }, disabled: true }), _jsxs(Box, { sx: styles.progressBarValues, children: [_jsx(Typography, { variant: 'body1', children: isDollarAmount ? formatDollarAmount(min, resolvedLocale) : formatNumber(min) }), _jsx(Typography, { variant: 'body1', children: isDollarAmount ? formatDollarAmount(max, resolvedLocale) : formatNumber(max) })] })] }));
};
export default ProgressBar;
